import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "HEADER/HeaderComp";
import GlobalAnnouncementPopup from "./GlobalAnnouncementPopup";
import { getUserProfile } from "USERPROFILE/userProfileSlice";
import Footer from "FOOTER/FooterComp";
import { setOOBO } from "USERPROFILE/user";
import { getCartCount } from "Cart/api";
import { clientAppVersion } from "./../../utils/globalVar";
import {
  resetLoginData,
  // getCategoryList,
  ooboLoginThunk,
  reloadOOBO,
  getClientThunk,
} from "../../redux/features/loginSlice";
import {
  getAppVersionThunk,
  setRelodeLandingPage,
  setappVersionReact,
  getNabCheckThunk,
  removeTags,
} from "../../redux/features/landingSlice";
import { getUnreadAlertThunk } from "../../redux/features/notificationSlice";
import GlobalMessage from "../GlobalMessage";
import Loading from "../Loading";
import { clearAllHcpState } from "CHECKOUT/HcpSlice";
import {
  clearMultipleAddressesState,
  deleteAllAddressesThunk,
} from "CHECKOUT/addressSlice";
import { getAnnouncement } from "USERPROFILE/announcementSlice";
import useAdminHelperFunction from "../DynamicField/useAdminHelperFunction";
import packageJson from "./../../../package.json";
import UpdateAppPopup from "./UpdateAppPopup";
import LoadingSpinner from "../LoadingSpinner";
import { useLogout } from "../../utils/useLogout";
import SessionExpiredPopup from "./SessionExpiredPopup";
import useTokenExpirationCheck from "./useTokenExpirationCheck";
import useIdentifySsoClient from "../../SSOClientsData/useIdentifySsoClient";
import { Clients_Data } from "../../SSOClientsData";

function Layout({ children }) {
  const dispatch = useDispatch();
  const login = useSelector((state) => state.login);
  const loadingState = useSelector((state) => state.loading);
  const cartState = useSelector((state) => state.cart);
  const { user } = useSelector((state) => state.accountManage);
  const { rejectedTagList, relodeLandingPage, appVersion, tagData } =
    useSelector((state) => state.landing);
  const { adminData } = useSelector((state) => state.support);

  const {
    apiStatusCode,
    // filterCategoryData,
    companyNumber,
    currentRoute,
    companyUrl,
    oobo,
    needsAddressVerification,
    currentPrivilege = [],
  } = login;
  const [sessionTimeout, setSessionTimeout] = useState(false);
  const [coNu, setCoNu] = useState("");
  const count = useRef(false);
  let navigate = useNavigate();

  useEffect(() => {
    if (!user?.roleId) {
      dispatch(getUserProfile()).then((resp) => {
        if (resp)
          localStorage.setItem(
            "ssoFlagStatus",
            resp?.payload?.ssoFlag ? true : false
          );
      });
    }
  }, []);

  useEffect(() => {
    if (tagData) {
      if (!window.location.pathname.includes("/searchResults")) {
        dispatch(removeTags());
      }
    }
  }, [window.location.pathname]);

  useEffect(() => {
    // dispatch(getItemsfromUserCartThunk());
    // let count = localStorage.getItem("cartTotal");
    dispatch(reloadOOBO(false));
    dispatch(getCartCount());
    dispatch(getNabCheckThunk());
  }, []);

  useEffect(() => {
    if (oobo) {
      dispatch(reloadOOBO());
      localStorage.removeItem("order_history_filter");
      localStorage.removeItem("order_history_data");
      localStorage.removeItem("order_history_payload");
      localStorage.removeItem("expired_item_search_selected_attributes");
      localStorage.removeItem("expired_item_search_selected_ids");
      localStorage.removeItem("new_item_search_selected_attributes");
      localStorage.removeItem("new_item_search_selected_ids");
      localStorage.removeItem("item_search_selected_attributes");
      localStorage.removeItem("item_search_selected_ids");
      localStorage.removeItem("item_search_payload");
      localStorage.removeItem("item_search_data");
      localStorage.removeItem("user_search_data");
      window.location.reload();
    }
  }, [oobo]);

  useEffect(() => {
    if (needsAddressVerification) {
      navigate(`/userProfile`);
    }
  }, [needsAddressVerification]);
  const { logout: globalLogout, ssoFlagStatus } = useLogout();

  const redirectUserAsperSSO = () => {
    let uatEnv = window.location.host.includes("uat");
    const envs = ["qa", "uat", "localhost", "dev"];
    const prodSsoLoginByEnv = envs.every(
      (e) => !window.location.host.includes(e)
    );
    dispatch(getClientThunk()).then((resp) => {
      let client = Clients_Data.find(
        (client) => client.compNumber === resp?.payload?.companyNumber
      );
      uatEnv && client?.isSsoClient
        ? window.location.replace(client?.ssoUatUrl)
        : prodSsoLoginByEnv && client?.isSsoClient
        ? window.location.replace(client?.ssoProdUrl)
        : navigate("/login");
    });
  };
  useEffect(() => {
     if (
      !login.apiStatusCode &&
      !login?.userInfoAttr &&
      !login?.userPrivilege?.length
    ) {
      // if (user?.ssoFlag) {
      if (sessionStorage.getItem("isOrderDetailDirectLink") == "true") {
        redirectUserAsperSSO();
      }else if (ssoFlagStatus || count.current) {
        navigate(`/ssosignout`);
      } else {
        navigate(`/login`);
      }
    }
  }, [login]);

  function clearStateFunc() {
    dispatch(clearAllHcpState());
    dispatch(clearMultipleAddressesState());
    dispatch(deleteAllAddressesThunk());
    dispatch(resetLoginData());
    window.document.cookie =
      "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }

  const location = useLocation();

  const logout = () => {
    globalLogout();
    const ssoF = user?.ssoFlag ? true : false;
    count.current = Boolean(ssoF);
    // setSsoFlagStatus(ssoF);
    // dispatch(clearAllHcpState());
    // dispatch(clearMultipleAddressesState());
    // dispatch(deleteAllAddressesThunk());
    // dispatch(resetLoginData());
    // document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    // localStorage.removeItem("userInfo");
    // localStorage.clear();
    // if ("caches" in window) {
    //   caches.keys().then((names) => {
    //     names.forEach((name) => {
    //       caches.delete(name);
    //     });
    //   });
    // }
    // if (relodeLandingPage === 0) {
    //   dispatch(setRelodeLandingPage(1));
    //   setTimeout(() => {
    //     window.location.reload();
    //   }, 0);
    // }

    // localStorage.setItem("version", appVersion ? appVersion : "2.0.0");
    // localStorage.setItem("companyNumber", companyNumber ? companyNumber : "");
    // localStorage.setItem("AppName", JSON.stringify(appName));
  };

  useEffect(() => {
    if (companyUrl && !window.location.href.includes(companyUrl)) {
      dispatch(resetLoginData());
    } else {
      // dispatch(getCategoryList());
    }
  }, []);

  useEffect(() => {
    if (sessionTimeout) {
      logout();
    }
  }, [sessionTimeout]);

  useEffect(() => {
    setTimeout(() => {
      setSessionTimeout(true);
    }, 1000 * 60 * 61);
  }, []);

  useEffect(() => {
    dispatch(getUnreadAlertThunk());
    dispatch(getAnnouncement());
  }, []);

  // const onHeaderCategory = (label) => {
  //   console.log(label, filterCategoryData);
  //   // if (filterCategoryData.length && label) {
  //   //   console.log(filterCategoryData, label);
  //   //   const searchAttributesData = filterCategoryData
  //   //     .filter((item) => item.label === label)[0]
  //   //     .categories.map((item) => item.name);
  //   //   dispatch(updateSearchAttributes({ [label]: searchAttributesData }));
  //   navigate("/searchResults");
  //   // }
  // };
  const ooboLogin = (data) => {
    dispatch(ooboLoginThunk(data));
    dispatch(setOOBO(null));
  };

  // Update App Version
  const [versionUpdate, setVersionUpdate] = useState(false);
  const [versionLoadingState, setVersionLoadingState] = useState(false);
  function caching(appV) {
    let version = localStorage.getItem("version");
    // if (version != packageJson.version) {
    if (appV && version != appV) {
      setVersionUpdate(true);
    }
  }

  function updateAppVersion(s) {
    if (s) {
      setVersionLoadingState(true);
      // clearStateFunc();
      globalLogout();
      const ssoF = user?.ssoFlag ? true : false;
      count.current = Boolean(ssoF);
      if (count.current) {
        navigate("/");
      } else {
        navigate("/login");
      }
      window.location.reload(true);
      // if ("caches" in window) {
      //   caches.keys().then((names) => {
      //     names.forEach((name) => {
      //       caches.delete(name);
      //     });
      //   });
      //   setVersionUpdate(false);

      // }
      // localStorage.clear();
      // localStorage.setItem(
      //   "version",
      //   appVersion ? appVersion : clientAppVersion
      // );
      // localStorage.setItem("AppName", appName ? JSON.stringify(appName) : "");
      setVersionLoadingState(false);
    }
  }

  useEffect(() => {
    dispatch(getAppVersionThunk()).then((data) => {
      // console.log("appVersion : ", data.payload);
      caching(data?.payload);
    });
  }, [appVersion]);

  if (rejectedTagList && rejectedTagList?.status === 403) {
    logout();
  }

  //   const location = useLocation();

  //   useEffect(() => {
  //     if(location.pathname === '/home' && relodeLandingPage === 0){
  //       // execute on location change

  //     }else if(relodeLandingPage === 1){
  //       dispatch(setRelodeLandingPage(0))
  //     }
  // }, [location]);

  //----- Token expiration functionality --------------//
  //todo - start
  // const [showPopup, setShowPopup] = useState(false);

  // const checkTokenExpiration = () => {
  //   const exp = login?.decodedTokenObject?.exp;
  //   const currentTimestamp = Date.now();

  //   if (!exp || exp <= Date.now()) {
  //     logout();
  //     return;
  //   }

  //   const timeDifference = exp - Date.now();
  //   const timeDifferenceInMinutes = timeDifference / 60000;
  //   const timeDifferenceInHours = timeDifference / 3600000;

  //   console.log("Token - Current Timestamp", currentTimestamp);
  //   console.log("Token Expiration timestamp", exp);
  //   console.log(
  //     "Token Expiration =>>>>",
  //     "is token Expired :",
  //     exp <= Date.now()
  //   );
  //   console.log("Token timeDifferenceInMinutes", timeDifferenceInMinutes);
  //   console.log("Token timeDifferenceInHours", timeDifferenceInHours);

  //   if (timeDifferenceInMinutes <= 5 && timeDifferenceInMinutes > 0) {
  //     setShowPopup(true);
  //   }
  // };

  // useEffect(() => {
  //   checkTokenExpiration();
  // }, [location.pathname]);

  //custom hook
  const { showPopup, setShowPopup, timeDifference } = useTokenExpirationCheck();

  //todo - End
  //----------------------------------------

  return (
    <>
      {showPopup && Math.round(timeDifference.toFixed(2)) !== 0 && (
        <SessionExpiredPopup
          logout={logout}
          setShowPopup={setShowPopup}
          timeDifferenceInMinutes={Math.round(timeDifference.toFixed(2))}
        />
      )}
      <Loading loadingState={loadingState} />
      <GlobalMessage />
      {versionLoadingState && <LoadingSpinner />}
      {versionUpdate && <UpdateAppPopup updateAppVersion={updateAppVersion} />}
      <Header
        cartCount={
          cartState?.totalCartCount || localStorage.getItem("cartTotal") || 0
        }
        logout={logout}
        // categoryListData={currentRoute === "/home" ? filterCategoryData : []}
        // onHeaderCategory={onHeaderCategory}
        ooboLogin={ooboLogin}
      />
      <GlobalAnnouncementPopup />
      {children}
      <Footer />
    </>
  );
}

export default Layout;
